export default __webpack_public_path__ + "static/media/sol.57b09a7d.png";